import React from "react";
import styles from "./index.module.scss";

interface ITip {
  tip: string; //支持带br换行符
}

export default (props: ITip) => {
  const createMarkup = (text) => {
    return { __html: text };
  };
  const getWbContent = (content) => {
    return <div dangerouslySetInnerHTML={createMarkup(content)}></div>;
  };
  return (
    <div className={styles.bgwrapper}>
      <div className={styles.backgroundImage}></div>
      <div className={styles.tip}>{getWbContent(props.tip)}</div>
    </div>
  );
};
